import orderBy from 'lodash/orderBy';
import take from 'lodash/take';
import uniqBy from 'lodash/uniqBy';
import { DateTime } from 'luxon';
import { ltLuxon } from '../helpers/ltLuxon';
import { CookieConstant } from '../constants';
import { sessionService } from '@life-time-inc/enterprise-framework-core';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class RecentClubService implements ltFramework.IRecentClubService {
	public mergeData(
		profileClubs: ltFramework.IRecentClub[],
		storedClubs: ltFramework.IRecentClub[]
	): ltFramework.IRecentClub[] {
		let mergedClubs: ltFramework.IRecentClub[];

		if (storedClubs) {
			mergedClubs = profileClubs.concat(storedClubs);
		}
		else {
			mergedClubs = profileClubs;
		}

		mergedClubs = this.removeDuplicates(mergedClubs);

		// return a maximum of 4 results from merged data
		return take(mergedClubs, 4);
	}

	public removeDuplicates(clubs: ltFramework.IRecentClub[]): ltFramework.IRecentClub[] {
		let cleanedData: ltFramework.IRecentClub[] = orderBy(
			clubs,
			(club: ltFramework.IRecentClub) => {
				return new Date(club.date).valueOf();
			},
			['desc']
		);

		// remove any .app extensions
		cleanedData = cleanedData.map((club: ltFramework.IRecentClub) => {
			if (club.link.indexOf('app')) {
				club.link = club.link.replace('.app', '');
			}
			return club;
		});

		return uniqBy(cleanedData, 'id');
	}

	public addClub(
		newClub: ltFramework.IRecentClub,
		currentClubs: ltFramework.IRecentClub[]
	): ltFramework.IRecentClub[] {
		let recentClubsObj: ltFramework.IRecentClub[] = currentClubs || [];

		// update recent club cookie if it exists so the banner still displays
		sessionService.setCookie(CookieConstant.cookieLastVisited, newClub.link, Infinity);

		// add the current club to the beginning of the list
		recentClubsObj.unshift(newClub);

		// validate dates are not in the future
		recentClubsObj = this.validateDates(recentClubsObj);

		// remove club if it is in the list already
		recentClubsObj = this.removeDuplicates(recentClubsObj);

		// trim the list to have a max of 4 items
		if (recentClubsObj.length > 4) {
			recentClubsObj.length = 4;
		}

		return recentClubsObj;
	}

	public validateDates(clubs: ltFramework.IRecentClub[]): ltFramework.IRecentClub[] {
		const recentClubs: ltFramework.IRecentClub[] = clubs;

		recentClubs.forEach((club: ltFramework.IRecentClub) => {
			if (ltLuxon(club.date).minus({ minutes: 1 }) > DateTime.now()) {
				club.date = DateTime.now().toISO();
			}
		});

		return recentClubs;
	}
}

export const recentClubService = new RecentClubService();
